import { render } from "./MEarnbySharing.vue?vue&type=template&id=03e97327&scoped=true"
import script from "./MEarnbySharing.vue?vue&type=script&lang=js"
export * from "./MEarnbySharing.vue?vue&type=script&lang=js"

import "./MEarnbySharing.vue?vue&type=style&index=0&id=03e97327&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e97327"]])

export default __exports__